var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.726,
    height: 24,
    viewBox: "0 0 19.726 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.518 -1.363)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.284 2.129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.164,26.767l-2.59-2.59V6.106a.744.744,0,0,0-.743-.743H17.261a.744.744,0,0,0-.743.743V23.58a.191.191,0,0,0,.056.135l2.115,2.115a.191.191,0,0,0,.135.056H31.252l2.4,2.4a1.072,1.072,0,0,0,1.516-1.516Z",
    transform: "translate(-16.518 -5.363)",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.518 1.363)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.192 0.192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.639,2.363H14.07a.552.552,0,0,0-.552.552V20.389L15.633,22.5H28.639a.552.552,0,0,0,.552-.554V2.915a.552.552,0,0,0-.552-.552Z",
    transform: "translate(-13.518 -2.363)",
    fill: "#e4efff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.23 2.137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.159,15.877a.383.383,0,0,1-.244-.088l-.839-.695a.383.383,0,1,1,.489-.59l.514.426.848-1.246a.383.383,0,0,1,.633.431l-1.085,1.594a.383.383,0,0,1-.263.164A.394.394,0,0,1,21.159,15.877Z",
    transform: "translate(-19.938 -13.516)",
    fill: "#0089ef"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.23 7.784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.159,45.355a.383.383,0,0,1-.244-.088l-.839-.695a.383.383,0,0,1,.489-.59l.514.426.848-1.246a.383.383,0,0,1,.633.431l-1.085,1.594a.383.383,0,0,1-.263.164A.365.365,0,0,1,21.159,45.355Z",
    transform: "translate(-19.938 -42.995)",
    fill: "#0089ef"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.23 13.511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.076,75.407a.381.381,0,0,1-.271-.112l-1.756-1.756A.383.383,0,0,1,20.591,73l1.756,1.756a.383.383,0,0,1-.271.654Z",
    transform: "translate(-19.937 -72.885)",
    fill: "#fa759e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.32,75.407a.383.383,0,0,1-.271-.654L21.805,73a.383.383,0,0,1,.542.542l-1.756,1.756A.382.382,0,0,1,20.32,75.407Z",
    transform: "translate(-19.937 -72.885)",
    fill: "#fa759e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 18.026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.518,96.453h1.563a.552.552,0,0,1,.552.554v1.561Z",
    transform: "translate(-13.518 -96.453)",
    fill: "#c00096"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.639,2.363H14.07a.552.552,0,0,0-.552.552v.575a.552.552,0,0,1,.552-.552h14.57a.552.552,0,0,1,.552.552V2.915A.552.552,0,0,0,28.639,2.363Z",
    transform: "translate(-13.518 -2.363)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.553 17.827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.834,94.417l.767.767a.875.875,0,0,0-.574.574l-.767-.767a3.463,3.463,0,0,0,.3-.271A3.518,3.518,0,0,0,83.834,94.417Z",
    transform: "translate(-83.26 -94.417)",
    fill: "#6dc9f7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.414,63.184a3.809,3.809,0,1,0,0,5.386A3.813,3.813,0,0,0,57.414,63.184Z",
    transform: "translate(-43.558 -50.44)",
    fill: "#0089ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.524,67.548a2.921,2.921,0,1,0,0,4.131A2.921,2.921,0,0,0,60.524,67.548Z",
    transform: "translate(-47.295 -54.177)",
    fill: "#6dc9f7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.215 14.395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.3,77.3a2.382,2.382,0,0,0-3.522,0,.462.462,0,0,0,0,.7,2.382,2.382,0,0,0,3.522,0A.462.462,0,0,0,64.3,77.3Z",
    transform: "translate(-60.618 -76.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.867,
    cy: 0.867,
    r: 0.867,
    transform: "translate(0.793 1.602) rotate(-67.486)",
    fill: "#0089ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.537,79.971a.283.283,0,1,0,.283.283A.283.283,0,0,0,71.537,79.971Z",
    transform: "translate(-69.216 -79.307)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.283,101.194l-2.73-2.73a.88.88,0,0,0-1.245,1.245l2.73,2.73a.88.88,0,1,0,1.245-1.245Z",
    transform: "translate(-72.773 -79.654)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.71,19.14a.192.192,0,0,0,.192-.192v-.93a.192.192,0,1,0-.383,0v.93A.192.192,0,0,0,12.71,19.14Z",
    transform: "translate(-12.518 -14.673)",
    fill: "#3a2c60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.378,24.562H45.9a.192.192,0,0,0,0-.383h-8.52a.192.192,0,0,0,0,.383Z",
    transform: "translate(-32.46 -19.808)",
    fill: "#3a2c60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.378,39.562H45.9a.192.192,0,0,0,0-.383h-8.52a.192.192,0,0,0,0,.383Z",
    transform: "translate(-32.46 -31.934)",
    fill: "#3a2c60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.378,54.562H45.9a.192.192,0,0,0,0-.383h-8.52a.192.192,0,0,0,0,.383Z",
    transform: "translate(-32.46 -44.061)",
    fill: "#3a2c60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.857,66.61a3.112,3.112,0,1,0,0,4.4A3.116,3.116,0,0,0,59.857,66.61Zm-.271,4.131a2.728,2.728,0,1,1,0-3.86,2.733,2.733,0,0,1,0,3.86Z",
    transform: "translate(-46.493 -53.374)",
    fill: "#3a2c60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.615,76.342a2.57,2.57,0,0,0-3.775,0,.653.653,0,0,0,0,.985,2.57,2.57,0,0,0,3.775,0,.653.653,0,0,0,0-.985Zm-.252.7a2.195,2.195,0,0,1-3.27,0,.27.27,0,0,1,0-.408,2.194,2.194,0,0,1,3.27,0,.27.27,0,0,1,0,.408Z",
    transform: "translate(-50.593 -61.31)",
    fill: "#3a2c60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.165,22.767l-2.589-2.59V2.106a.744.744,0,0,0-.743-.743H13.262a.744.744,0,0,0-.743.743V3.751a.192.192,0,0,0,.383,0V2.106a.361.361,0,0,1,.36-.36h14.57a.361.361,0,0,1,.36.36V19.861a1.064,1.064,0,0,0-.515-.136,1.1,1.1,0,0,0-.206.02l-.574-.573a4,4,0,0,0-6.378-4.816H17.436a.192.192,0,0,0,0,.383h2.822a4,4,0,0,0-.551,2.491H17.436a.192.192,0,0,0,0,.383h2.332a3.993,3.993,0,0,0,6.285,2.4l.573.573a1.07,1.07,0,0,0,.253.914H15.017v-1.37a.745.745,0,0,0-.743-.745H12.9V6.625a.192.192,0,0,0-.383,0V19.58a.191.191,0,0,0,.056.135l2.115,2.115a.191.191,0,0,0,.135.056H27.253l2.4,2.4a1.072,1.072,0,1,0,1.516-1.516ZM21.124,19.358a3.617,3.617,0,1,1,5.116,0A3.622,3.622,0,0,1,21.124,19.358Zm5.227.415c.053-.048.108-.093.159-.144s.1-.106.144-.159l.432.432a1.068,1.068,0,0,0-.3.3Zm-11.717.361v1.1l-1.461-1.461h1.1A.362.362,0,0,1,14.634,20.134Zm16.26,3.878a.708.708,0,0,1-.974,0l-2.729-2.73a.689.689,0,0,1,.974-.974l2.73,2.73A.69.69,0,0,1,30.894,24.012Z",
    transform: "translate(-12.519 -1.363)",
    fill: "#3a2c60"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5);
export default __webpack_public_path__ + "static/media/Step5.96f2ce9a60a45a5955492d4d5963f587.svg";
export { ForwardRef as ReactComponent };